import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.sandy,
  textColor: colors.white,
  textColorDark: colors.darkNight,
  textColorLight: colors.white
};
export default pencilBanner;